import { FLOLDER, getIn18Text } from 'api';
import { thunkHelperFactory } from '@web-common/utils/redux_utils';
import { request } from '@web-mail/state/slice/request';
import { createAllSuborbinateFolderList, formatColleague2TreeData, formatSubordinateContact2TreeData, getSubordinateSlice, } from '@web-mail/utils/slice';
import { treeDFS, treeReplaceDFS } from '@web-mail/util';
const ReducerName = 'SubordinateListReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'loadFolderData_sd',
    request: async (params, thunkAPI) => {
        const res = await request.doGetColleagueList();
        return res;
    },
    fulfilled: (rootState, action) => {
        const subordinateList = action.payload || {};
        const { sliceId } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state || !subordinateList.length) {
            return;
        }
        if (process.env.BUILD_ISEDM && subordinateList.length > 1) {
            subordinateList.unshift({
                email: 'allSubordinate',
                nickName: getIn18Text('QUANBUXIAS'),
                id: 'allSubordinate',
            });
        }
        state.subordinateList = subordinateList;
        state.subordinateTreeList = subordinateList.map(formatSubordinateContact2TreeData);
        state.selectedSubordinateKeys = state.subordinateTreeList[0];
        state.expandedKeys = [state.subordinateTreeList[0].key];
        state.selectedFolder = {
            relationEmailList: state.subordinateTreeList[0].relationEmailList || [],
            subordinateId: subordinateList[0].id,
            key: state.subordinateTreeList[0].key,
            ids: state.subordinateTreeList[0].ids || [],
        };
    },
    rejected: (state, action) => {
        console.error('loadFolderData_sd error');
    },
});
thunkHelper({
    name: 'loadResignListData_sd',
    request: async (params, thunkAPI) => {
        const res = await request.doGetColleagueList();
        return res;
    },
    fulfilled: (rootState, action) => {
        const resignList = action.payload || {};
        const { sliceId } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state || !resignList.length) {
            return;
        }
        state.resignList = resignList;
    },
    rejected: (state, action) => {
        console.error('loadResignListData_sd error');
    },
});
thunkHelper({
    name: 'getColleagueFolderList_sd',
    request: async ({ sliceId, id }, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const rootState = thunkAPI.getState().mailReducer;
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        const _id = id == '' ? state.selectedFolder.subordinateId : id;
        if (_id === 'allSubordinate') {
            return {
                data: null,
                relationList: [],
            };
        }
        const selectedSubordinate = state.subordinateList.find(item => item.id === _id);
        if (!selectedSubordinate) {
            return {
                data: null,
                relationList: [],
            };
        }
        const relationList = await request.doGetColleagueRelationList(_id);
        const selectedSubordinateEmail = selectedSubordinate.email;
        const emails = relationList.map(item => item.email);
        relationList.unshift({
            name: selectedSubordinateEmail,
            email: selectedSubordinateEmail,
            accountId: selectedSubordinate.id,
        });
        const data = await request.doGetColleagueFolderList(_id, emails);
        if (process.env.BUILD_ISEDM) {
            setTimeout(() => {
                if (relationList.length > 1) {
                    dispatch(Thunks.getUnFollowNumber_sd({ type: 'subordinate', id: _id, sliceId, email: relationList.map(r => r.email) }));
                }
                else {
                    dispatch(Thunks.getUnFollowNumber_sd({ type: 'account', id: _id, sliceId, email: [selectedSubordinateEmail] }));
                }
            }, 0);
        }
        return {
            selectedSubordinate,
            data,
            relationList,
        };
    },
    pending: (rootState, action) => {
        const { sliceId } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state || !!state.showSubordinateMock) {
            return;
        }
        state.colleagueListLoading = true;
    },
    fulfilled: (rootState, action) => {
        const { data, relationList, selectedSubordinate } = action.payload || {};
        const { sliceId, id, refresh } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        const _id = id == '' ? state.selectedFolder.subordinateId : id;
        const treeList = state.treeList;
        if (data === null) {
            state.treeList = treeList;
            if (_id === 'allSubordinate') {
                state.treeList = createAllSuborbinateFolderList();
            }
        }
        else {
            state.treeList = formatColleague2TreeData({ colleague: formatSubordinateContact2TreeData(selectedSubordinate), data, relationList, colleagueAccountId: _id });
        }
        if (state.colleagueListLoading) {
            state.colleagueListLoading = false;
        }
        if (state.treeList.length) {
            const defaultFolder = state.treeList[0];
            state.selectedFolder = {
                relationEmailList: defaultFolder.relationEmailList || [],
                subordinateId: _id,
                key: defaultFolder.key,
                ids: defaultFolder.ids || [],
            };
        }
        if (refresh) {
            const expandedKeys = [];
            const expandedSet = new Set(state.expandedKeys);
            let isSelectedFolderExist = false;
            treeDFS(state.treeList, (item) => {
                if (expandedSet.has(item.key)) {
                    expandedKeys.push(item.key);
                }
                if (item.key === state.selectedFolder.key) {
                    isSelectedFolderExist = true;
                }
            });
            if (!expandedKeys.length && state.treeList.length) {
                expandedKeys.push(state.treeList[0].key);
            }
            state.expandedKeys = expandedKeys;
            if (!state.selectedFolder.key || !isSelectedFolderExist) {
                state.selectedFolder = {
                    ids: [],
                    relationEmailList: [],
                    subordinateId: state.selectedFolder.subordinateId,
                    key: state.selectedFolder.key,
                };
                state.selectedMailId = {
                    id: '',
                };
            }
        }
    },
    rejected: (rootState, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        if (state.colleagueListLoading) {
            state.colleagueListLoading = false;
        }
        console.error('getColleagueFolderList_sd error');
    },
});
thunkHelper({
    name: 'getUnFollowNumber_sd',
    request: async ({ sliceId, id, type, email }, thunkAPI) => {
        const rootState = thunkAPI.getState().mailReducer;
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        const _id = id == '' ? state.selectedFolder.subordinateId : id;
        const selectedSubordinate = state.subordinateList.find(item => item.id === _id);
        if (!selectedSubordinate) {
            return {
                customerCount: 0,
                nonCustomerCount: 0,
            };
        }
        let isMultiple = false;
        if (type === 'subordinate') {
            isMultiple = true;
        }
        else if (type === 'account') {
            isMultiple = false;
        }
        const { customerCount, nonCustomerCount } = await request.doGetColleagueUnFollowNumber(_id, isMultiple, email || []);
        return {
            customerCount,
            nonCustomerCount,
        };
    },
    pending: (rootState, action) => {
        const { sliceId } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state || !!state.showSubordinateMock) {
            return;
        }
    },
    fulfilled: (rootState, action) => {
        const { customerCount, nonCustomerCount } = action.payload || {};
        const { sliceId, id, type, email } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        if (type === 'subordinate') {
            state.treeList = state.treeList.map(node => {
                const { nodeType, originId } = node;
                if (nodeType === 'mutiAccountFolder' && originId == 'CUSTOMER_UNFOLLOW') {
                    node.nodeData = { entry: { mailBoxTotal: customerCount } };
                }
                if (nodeType === 'mutiAccountFolder' && originId == 'UNFOLLOW') {
                    node.nodeData = { entry: { mailBoxTotal: nonCustomerCount } };
                }
                return node;
            });
        }
        if (type === 'account' && email && email[0]) {
            state.treeList = treeReplaceDFS(state.treeList, (node) => {
                var _a, _b;
                const { nodeType, nodeData, colleagueAccountId, relationEmailList } = node;
                if (nodeType === 'folder') {
                    const mailBoxId = (nodeData === null || nodeData === void 0 ? void 0 : nodeData.mailBoxId) || (nodeData === null || nodeData === void 0 ? void 0 : nodeData.entry.mailBoxId);
                    if (colleagueAccountId === id && relationEmailList && relationEmailList[0].email === email[0]) {
                        if (mailBoxId == FLOLDER.CUSTOMER_UNFOLLOW && customerCount) {
                            return Object.assign(Object.assign({}, node), { nodeData: Object.assign(Object.assign({}, node.nodeData), { entry: Object.assign(Object.assign({}, (_a = node === null || node === void 0 ? void 0 : node.nodeData) === null || _a === void 0 ? void 0 : _a.entry), { mailBoxTotal: customerCount }) }) });
                        }
                        if (mailBoxId == FLOLDER.UNFOLLOW && nonCustomerCount) {
                            return Object.assign(Object.assign({}, node), { nodeData: Object.assign(Object.assign({}, node.nodeData), { entry: Object.assign(Object.assign({}, (_b = node === null || node === void 0 ? void 0 : node.nodeData) === null || _b === void 0 ? void 0 : _b.entry), { mailBoxTotal: nonCustomerCount }) }) });
                        }
                        return node;
                    }
                    return node;
                }
                return node;
            });
        }
    },
    rejected: (rootState, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        console.error('getUnFollowNumber_sd error');
    },
});
thunkHelper({
    name: 'loadFolderData_sd_mock',
    request: async ({ show }) => {
        if (!show) {
            await request.doUpdateColleaguePromotion();
            return false;
        }
        else {
            const temp = await request.doGetColleaguePromotion();
            return temp;
        }
    },
    fulfilled: (rootState, action) => {
        const { sliceId, show: showParam } = action.meta.arg || {};
        const state = getSubordinateSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        const subordinateList = [
            {
                email: 'yuangong1@xx.com',
                nickName: '员工1',
                id: '员工1',
            },
            {
                email: 'yuangong2@xx.com',
                nickName: '员工2',
                id: '员工2',
            },
            {
                email: 'yuangong3@xx.com',
                nickName: '员工3',
                id: '员工3',
            },
        ];
        if (!showParam) {
            state.hasCloseSubordinateMock = true;
        }
        const show = !!action.payload;
        if (show) {
            state.subordinateList = subordinateList;
            state.subordinateTreeList = subordinateList.map(formatSubordinateContact2TreeData);
            state.treeList = [
                subordinateList.map(formatSubordinateContact2TreeData).map((item, index) => {
                    item.children = [
                        {
                            title: '全部文件夹',
                            key: '全部文件夹' + index,
                            isLeaf: true,
                            nodeType: 'folder',
                            originId: '全部文件夹' + index,
                            colleagueAccountId: '员工' + index,
                            ids: [],
                        },
                    ];
                    return item;
                })[0],
            ];
        }
        else {
            state.subordinateList = [];
            state.subordinateTreeList = [];
            state.treeList = [];
        }
        state.showSubordinateMock = !!show;
    },
    rejected: (state, action) => {
        console.error('loadFolderData_sd_mock error');
    },
});
export const FolderThunks_sd = Thunks;
export const FolderExtraReducersList_sd = ReducersList;
